'use client'

import MainContainer from "@/components/common/main/_main";
import Footer from "@/components/common/footer/_footer";
import Header from "@/components/common/header/_header";
import OneLineNotice from "@/components/common/oneLine";
import FooterMo from "@/components_mobile/common/_footer";
import HeaderMo from "@/components_mobile/common/_header";
import MobileContainer from "@/components_mobile/common/_main";
import { DeviceContext } from "@/context/deviceContext";
import MoFloatMenuProvider from "@/context/moFloatMenuContext";
import { ReactNode, useContext, useEffect, useState } from "react";
import { useNav } from "@/context/navContext";
import Lottie from "react-lottie-player";
import loadingJson from "@/public/media/load_data.json"
import HistoryProvider from "@/context/historyContext";
import { usePathname, useRouter } from "next/navigation";
import WebPushProviders from "@/context/webPushProviders";
import { registerPush } from "@/util/registerPush";
import { useTranslations } from "next-intl";
import FloatSharePopupMessage from "@/components_mobile/float/share_popup";

export default function Structre({ children }: { children: ReactNode }) {
    const { mobileMode } = useContext(DeviceContext)
    const [sportsNewsPage, setSportsNewsPage] = useState<boolean>(false)
    const { click } = useNav()
    
        
    const pathName = usePathname()


    useEffect(() => {
        if(mobileMode && pathName == '/sports_news/'){
            setSportsNewsPage(true)
        }else{
            setSportsNewsPage(false)
        }
    }, [pathName, mobileMode])


    function setDynamicVH() {
        // 1vh = 실제 화면 높이 / 100
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    useEffect(() => {
        setDynamicVH();
        window.addEventListener("resize", setDynamicVH);
        return () => window.removeEventListener("resize", setDynamicVH);
    }, []);

    //가로모드알림
    useEffect(() => {
        function handleOrientation() {
            const isLandscape = window.matchMedia("(orientation: landscape)").matches;
            const noticeEl = document.querySelector(".mobileLandscapeNotice");

            if (!noticeEl) return;

            if (isLandscape) {
                noticeEl.classList.add("active");
            } else {
                noticeEl.classList.remove("active");
            }
        }

        handleOrientation();
        window.addEventListener("resize", handleOrientation);
        window.addEventListener("orientationchange", handleOrientation);

        return () => {
            window.removeEventListener("resize", handleOrientation);
            window.removeEventListener("orientationchange", handleOrientation);
        };
    }, []);
    
    //push
    useEffect(() => {
        registerPush(); // 앱 실행 시 푸시 등록
        //로그인 직후 다시 설정 필요할수도
        //서버쪽하고 확인하고 세팅 필요
    }, []);

    const t = useTranslations('Sentence')

    return (
        <div id="root-app">
            {
                !mobileMode
                    ? <div id="app-wrap">
                        <Header />
                        <MainContainer>
                            {
                                click
                                    ? <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                                    : children
                            }
                        </MainContainer>
                        <FooterMo />
                    </div>
                    :
                    <WebPushProviders> {/** 모바일 에서만 실행하도록 */}
                        <HistoryProvider>
                            <MoFloatMenuProvider>
                                <div id="mobile-wrap">
                                    <div className={`mobileLandscapeNotice`}>
                                        <div>{t('portraitMode1')}<br />{t('portraitMode2')}</div>
                                    </div>
                                    <HeaderMo />
                                    <div className={`safe-area`}>
                                        {/* <HeaderUserInfo /> */}
                                        { !sportsNewsPage && <OneLineNotice /> }                                
                                        <MobileContainer>
                                            {
                                                click
                                                    ? <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                                                    : children
                                            }
                                        </MobileContainer>
                                        { !sportsNewsPage && <FooterMo /> }
                                    </div>
                                </div>
                            </MoFloatMenuProvider>
                        </HistoryProvider>
                    </WebPushProviders>
            }
            <Footer />
        </div>
    )
}